import { passwordComplexityOptions } from "../../security/password-complexity-options.model";
import { AccountingConfigurationsModel } from "../accounting/account-settings.model";
import { BaseModel } from "../base.model";
import { IdentityProvidersModel } from "./identity-providers.model";

export class SettingsModel extends BaseModel {
    accountingConfigurations: AccountingConfigurationsModel[] = [];
    enableAnonymousUserSignUp?: boolean;
    enableEmailVerification?: boolean;
    fileCompressionType?: string;
    identityProviders?: IdentityProvidersModel = new IdentityProvidersModel();
    locked?: boolean;
    logRequestBody?: boolean;
    logResponseBody?: boolean;
    permittedExtensions: string[] = [];
    uxVersion?: string;
    defaultAIChatService?: string;
    defaultAIEmbeddingService?: string;
    defaultPaymentGatewayId?: string;
    defaultMarketplacePaymentGatewayId?: string;
    defaultAccountingCompanyId?: string;
    serverUrl?: string;
    checkVersion?: boolean;
    passwordComplexityOptions?: passwordComplexityOptions;
}

